require('expose-loader?BVBanners!../../../src/globals/components/banners');
